export default "__VITE_ASSET__CzwpSDfm__"